module.exports = __webpack_public_path__ + "media/images/warning-box-c3e0647c30338cf0a5bcf44dda8ed3c68e91dc09e779ed3f171ae7f854a35c38.svg";